import { render, staticRenderFns } from "./schema.vue?vue&type=template&id=b1c0121c&scoped=true&"
import script from "./schema.vue?vue&type=script&lang=ts&"
export * from "./schema.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c0121c",
  null
  
)

export default component.exports